import $ from 'jquery';
class Documents {

    constructor(){
        if ($("#documents-upload-button").length != 0){
            this.events();
        }
    }

    events() {
        //  Register Listeners
        $("#documents-upload-button").on("click", this.documentsButtonPressed.bind(this));
    }

    //  Methods
    documentsButtonPressed(e){
        $("#documents-upload-button").addClass("d-none");
        $("#documents-upload-form").removeClass("d-none");
    }
}
export default Documents;